import logo from './logo.svg';
import './App.css';
import Nav from './components/Nav'
import DAO from './components/DAO'
import Claim from './components/Claim'
import Keys from './components/Keys'
import Burn from './components/Burn'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import Landing from './components/Landing'
import SideNav from './components/SideNav';
import VibeStation from './components/MediaPlayer';
import OgBuy from './components/OgBuy';
import Recruit from './components/Recruit';
import {owners} from './components/recruit_helper'
import {useState,useEffect} from 'react';
import { ethers } from 'ethers';
import axios from 'axios';


function App() {
  const referees = ['','','','','','','']

  //DAO PROPS
  const[voteOptions,setVoteOptions] = useState([]);
  const[connected,setConnected] = useState(false);
  const[votingGrid,setVotingGrid] = useState(referees);
  const[accountChanged,setAccountChanged] = useState(false);

  
  const apiUrl = process.env.REACT_APP_API_URL
  const getVoteOptions = async () =>{
    if(voteOptions.length>0){
        console.log("Ran From Memory")
        
        return
    }
    const _voteOptions = await axios.get(`${process.env.REACT_APP_API_URL}/dao/voteOptions`)
    setVoteOptions(_voteOptions.data);
    console.log("Fetched From API")
    return;
}

const findFriends = async() => {
  try{
    if(window.ethereum){
      const provider = new ethers.providers.Web3Provider(window.ethereum,"any");
      const accounts = await provider.listAccounts();
      if(accounts.length>0){
        const account = accounts[0];
        console.log("Finding Friends for", account)
        const isOgHelper = owners.filter(owner => owner == account);
                if(isOgHelper.length==0){
                  setVotingGrid(['','','','','','',''])
                  return
                }
         
          const friends = await axios.get(`${process.env.REACT_APP_API_URL}/recruit/getFriends/${account}`)
          setVotingGrid(friends.data.payload);

        }

    
     
    }
  }
  catch(err){
    console.log(err);

  }
}

if(window.ethereum){
  window.ethereum.on('accountsChanged',(accounts)=>{
    setAccountChanged(!accountChanged);
    console.log("Account Changed");
  })

}


useEffect(() =>{
  getVoteOptions();
  findFriends();
},[])
 
useEffect(()=>{
  console.log("finding!")
  findFriends()
},[accountChanged])
   
  
  return (
<>
<Router>
  <Nav/>
  {/* <VibeStation/> */}
  {/* <SideNav/> */}



  <Routes>
  <Route path="/" element={<FadeIn duration={600}> <Landing/> </FadeIn>}></Route>
    <Route 
      path="/dao" 
      element={<FadeIn duration={600}> 
      <DAO voteOptions={voteOptions} setVoteOptions={setVoteOptions} connected={connected} setConnected={setConnected}/> 
      </FadeIn>}>
    </Route>


    <Route path="/claim" element={<FadeIn duration={500}><Claim/></FadeIn>}></Route>
    <Route path="/Buy" element={<FadeIn duration={500}><OgBuy/></FadeIn>}></Route>
    <Route path="/burn" element ={<FadeIn duration={500}><Burn/></FadeIn>}></Route>
    <Route path="/keys" element={<FadeIn duration={500}><Keys/></FadeIn>}></Route>
    <Route path ='/recruit' element={<Recruit votingGrid ={votingGrid} setVotingGrid={setVotingGrid}></Recruit>}></Route>

    <Route></Route>

  </Routes>
</Router>

</>
  );
}

export default App;
